import {Matcher} from '@/lib/axiosAddTransforms'

const matchers: Matcher[] = [
  {
    test: /^\/banks\/?$/,
    method: 'post',
    transform: {
      request: (payload) => {
        const {bizId} = payload.data
        payload.data.ownerName = payload.data.owner
        payload.url = `/bizs/${bizId}/bank-accounts/`
        return payload
      },
      response: (data) => {
        if(!data || !data.id) {
          return data
        }
        return bankResponse(data)
      },
    },
  },
  {
    test: /^\/banks\/?$/,
    method: 'get',
    transform: {
      request: (payload) => {
        const {bizId} = payload.data
        payload.url = `/bizs/${bizId}/bank-accounts/`
        return payload
      },
      response: (data) => {
        if(!data || !data.results) {
          return data
        }
        data.results = data.results.map((result) => bankResponse(result))
        return data
      },
    },
  },
  {
    test: /^\/banks\/\$id\/?$/,
    method: 'delete',
    transform: {
      request: (payload) => {
        const {bizId, id} = payload.data
        payload.url = `/bizs/${bizId}/bank-accounts/${id}`
        return payload
      },
      response: (data) => {
        if(!data || !data.id) {
          return data
        }
        return removeBankResponse(data)
      },
    },
  },
  {
    test: /^\/owner-name\/?$/,
    method: 'post',
    transform: {
      request: (payload) => {
        payload.url = '/bank-accounts/search-owner-name'
        return payload
      },
      response: (data) => {
        if(!data || !data.ownerName) {
          return data
        }
        return searchOwnerResponse({...data})
      },
    },
  },
]

const bankResponse = (data) => {
  const {
      id, name, bankCode, ownerName, number, 
      isTransferAvailable, isWithdrawalAvailable, isTransferPasswordInputRequired
    } = data
  return {
    id: String(id),
    name,
    code: bankCode,
    owner: ownerName,
    number,
    isTransfer: isTransferAvailable,
    isWithdrawal: isWithdrawalAvailable,
    isTransferPasswordInputRequired
  }
}

const removeBankResponse = (data) => {
  const {id} = data
  return {
    id,
  }
}

const searchOwnerResponse = (data) => {
  const {ownerName} = data
  return {
    ownerName,
  }
}

export {bankResponse}

export default matchers
